module.exports = __webpack_public_path__ + "7253aa3a1391444775064f0b55e9b9c8.png";